import PropTypes from "prop-types";
import moment from "moment";

const DateTimeDisplay = ({dateTime, parseFormat, format}) => {
  if (!dateTime) return null;
  return moment(dateTime, parseFormat || moment.ISO_8601, true).format(format);
};

DateTimeDisplay.propTypes = {
  dateTime: PropTypes.string,
  parseFormat: PropTypes.string,
  format: PropTypes.string,
};

DateTimeDisplay.defaultProps = {
  parseFormat: '',
  format: 'YYYY-MM-DD HH:mm:ss',
};

export default DateTimeDisplay;


// WEBPACK FOOTER //
// ./src/common/DateTimeDisplay.js